import { render, staticRenderFns } from "./ModalHistoricoAtendimento.vue?vue&type=template&id=2427ae5e&scoped=true"
import script from "./ModalHistoricoAtendimento.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoAtendimento.vue?vue&type=style&index=0&id=2427ae5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427ae5e",
  null
  
)

export default component.exports